import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router'
import { SortOrder } from "antd/lib/table/interface";
import { Layout, Table, Pagination, Modal, Form, Input } from 'antd';
import { AuthButton, AuthButtonAuthorities } from '../../core/CoreForm'
import { Header, ContentEx as Content, FooterButtonArea, Footer, FunctionTitle, CommonMessage } from '../../core/CorePageContents'
import styles from './MutualAidResultDetail.module.css';
import * as Module from '../../../modules/prime/mutual-aid/mutualAidModule';
import * as Model from '../../../modules/prime/mutual-aid/mutualAidModel';
import { initMessages } from '../../../modules/core/commonMessageModule';
import * as CONSTANTS from '../../../constants/constants';
import * as messagesUtils from '../../../utils/messagesUtils';
import * as formatUtils from "../../../utils/formatUtils";
import * as Utils from '../../../utils/utils';
import * as validationRules from '../../../validation/coreRules';
import AuthButtonStyles from '../../core/css/AuthButton.module.css';
import { initApiResult, storedApiResult, setApiResult } from '../../../modules/core/bffApiModule';
import { EyeFilled, EyeInvisibleFilled } from '@ant-design/icons';
import { useDropzone } from 'react-dropzone';

const XlsxPopulate = require('xlsx-populate');

interface titleInterface {
  title: string;
}

export const MutualAidResultDetail = (props: titleInterface) => {

  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const apiResult = useSelector(storedApiResult);
  let dataList = useSelector(Module.storedResultDetailList);
  let total = useSelector(Module.storedResultDetailTotal);
  let allConstructionCodeList = useSelector(Module.storedResultDetailAllConstructionCodeList);
  let criteria = useSelector(Module.storedResultDetailCriteria);
  let history = useHistory();
  let errorReportModalVisibleState = useSelector(Module.storedErrorReportModalVisibleState);
  let errorReportModalList = useSelector(Module.storedResultErrorReportList);
  let errorReportModalTotal = useSelector(Module.storedErrorReportModalTotal);
  let errorReportModalCriteria = useSelector(Module.storedErrorReportModalCriteria);
  let errorReportAttachModalVisibleState = useSelector(Module.storedErrorReportAttachModalVisibleState);
  let errorReportAttachModalResultList = useSelector(Module.storedErrorReportAttachModalResultList);
  let errorReportAttachModalMessage = useSelector(Module.storedErrorReportAttachModalMessage);
  let resultDownloadModalVisibleState = useSelector(Module.storedResultDownloadModalVisibleState);

  const errorReportInfoList: Model.putErrorReportAttach.Dest[] = [];

  // 一度に処理可能なファイル数
  const MAX_FILES = 100;
  // 一度に送信可能なバイト数(1mb)
  const MAX_BYTES = 1 * 1024 * 1024;
  // エラーレポートの最終行（エクセルの最大行）
  const ERROR_REPORT_MAX_ROW = 1048576;
  // エラー発生行の列
  const ERROR_REPORT_ERROR_CAUSED_ROW_COLUMN = 4;
  // メッセージIDの列
  const ERROR_REPORT_MESSAGE_ID_COLUMN = 12;
  // エラー・警告内容の列
  const ERROR_REPORT_MESSAGE_COLUMN = 19;
  // エラーとなった値の列
  const ERROR_REPORT_ERROR_VALUE_COLUMN = 60;

  useEffect(() => {
    // API呼出引数
    let param: Model.getMutualAidResultDetailDataList.Request = {
      linkedDatetime: criteria.linkedDatetime,
      sortItem: criteria.sortItem,
      sortOrder: criteria.sortOrder,
      offset: criteria.offset,
      limit: criteria.limit,
      isFirst: allConstructionCodeList?.length > 0 ? "0" : "1",
    }
    dispatch(Module.getResultDetailAsync(param));
  },
    [criteria]
  );

  useEffect(() => {
    // エラー一覧ダイアログを開いている場合、実行（遷移してきただけで動かないように）
    if (errorReportModalVisibleState) {
      // NowLoading表示
      dispatch(initApiResult());

      // API呼出引数
      let param: Model.getErrorReport.Request = {
        linkedDatetime: criteria.linkedDatetime,
        sortItem: errorReportModalCriteria.sortItem,
        sortOrder: errorReportModalCriteria.sortOrder,
        offset: errorReportModalCriteria.offset,
        limit: errorReportModalCriteria.limit,
      }
      dispatch(Module.getErrorReport(param));
    }
  },
    [errorReportModalCriteria]
  );

  // 連携日時が設定されていない場合、一覧画面へ遷移します。
  if (criteria.linkedDatetime === "") {
    history.push(CONSTANTS.PATH_PRIME_MUTUAL_AID_RESULT);
    return <></>;
  }

  // APIが正常終了した時の処理
  if (CONSTANTS.API_STATUS_INITIAL !== apiResult.status
    && "" === apiResult.errorCode
    && CONSTANTS.REQUEST_METHOD_PUT === apiResult.requestMethod
    && (
      CONSTANTS.URL_MUTUAL_AID_ERROR_REPORT_ATTACH === apiResult.url
      || CONSTANTS.URL_MUTUAL_AID_ERROR_REPORT === apiResult.url
    )
  ) {

    // API結果情報を初期化します。
    dispatch(initApiResult());

    // API呼出引数
    let param: Model.getMutualAidResultDetailDataList.Request = {
      linkedDatetime: criteria.linkedDatetime,
      sortItem: criteria.sortItem,
      sortOrder: criteria.sortOrder,
      offset: criteria.offset,
      limit: criteria.limit,
      isFirst: allConstructionCodeList?.length > 0 ? "0" : "1",
    }
    dispatch(Module.getResultDetailAsync(param));
  }

  function CsvUploader() {
    const onDrop = useCallback(async (acceptedFiles: File[], fileRejections: any[]) => {
      errorReportInfoList.length = 0;
      dispatch(Module.setErrorReportAttachModalMessage(""));
      dispatch(Module.setErrorReportAttachModalResultList([]));
      // 共通メッセージ情報を初期化します。
      dispatch(initMessages());

      if (acceptedFiles.length > MAX_FILES) {
        dispatch(Module.setErrorReportAttachModalMessage("一度に指定できるファイルは" + MAX_FILES + "ファイルまでです。"));
        return;
      }
      if (fileRejections.length > 0) {
        dispatch(Module.setErrorReportAttachModalMessage("xlsx形式以外のファイルは指定できません。"));
        return;
      }

      // NowLoading表示
      dispatch(initApiResult());

      try {
        // 全ファイル分の非同期処理（Promise）の配列を作成
        const promises = acceptedFiles.map(async (file: any) => {
          return await readErrorReport(file);
        });

        // すべてのファイル処理が完了するまでここで待機
        const processedResults = await Promise.all(promises);
        const failedResults = processedResults.filter((r) => r.result !== "〇");

        failedResults.sort((a, b) => a.fileName.localeCompare(b.fileName, 'ja')); // リストをファイル名でソート
        errorReportInfoList.sort((a, b) => a.fileName.localeCompare(b.fileName, 'ja')); // リストをファイル名でソート

        // すべて終わったら一括でステートを更新（エラーになったファイルがあれば、画面に結果が表示される）
        dispatch(Module.setErrorReportAttachModalResultList(failedResults));

        // エラーになったファイルが無ければ送信
        if (failedResults.length === 0) {
          // API呼出
          sendErrorReportInfo();
        } else {
          // API呼出しないが、「Now Loading」を解除するため、ステータスに初期値以外を設定する
          dispatch(setApiResult({ status: CONSTANTS.API_STATUS_200, errorCode: "", requestMethod: "", url: "" }));
        }

      } catch (error) {
        console.error("エクセル解析エラー:", error);
        alert("ファイルの処理中にエラーが発生しました。");
      }
    }, []);

    /**
     * エラーレポートファイル読込
     * @param selectedFile 
     * @returns 
     */
    const readErrorReport = async (selectedFile: any) => {
      const companyInfo: Model.putErrorReportAttach.Info[] = [];
      const projectInfo: Model.putErrorReportAttach.Info[] = [];
      const workerInfo: Model.putErrorReportAttach.Info[] = [];

      // ファイルをArrayBufferとして読み込み
      const buffer = await selectedFile.arrayBuffer();
      // XlsxPopulateでエクセルを解析
      const workbook = await XlsxPopulate.fromDataAsync(buffer);
      // 最初のシートを取得
      const sheet = workbook.sheet(0);
      // シートのフォーマットチェック
      if (sheet.name() !== "API連携データ取込結果エラーレポート") {
        return {
          fileName: selectedFile.name,
          result: "×",
          value: "シート名があっていません。",
        };
      }

      // 工事コードが一覧にあるかどうか
      const constructionCode = sheet.cell(7, 14).value();
      if (!allConstructionCodeList.includes(constructionCode)) {
        return {
          fileName: selectedFile.name,
          result: "×",
          value: "工事コードが連携結果一覧にありません。"
        };
      }

      // エラー情報取得
      let row = getStartRow("エラー詳細", sheet, 1); // エラー詳細行まで進む
      let checkResult: any[] = [];
      row = setErrorInfo(sheet, row, "会社情報", companyInfo, selectedFile.name, checkResult);
      if (checkResult.length > 0) {
        return checkResult[0];
      }
      row = setErrorInfo(sheet, row, "工事情報", projectInfo, selectedFile.name, checkResult);
      if (checkResult.length > 0) {
        return checkResult[0];
      }
      row = setErrorInfo(sheet, row, "就労情報", workerInfo, selectedFile.name, checkResult);
      if (checkResult.length > 0) {
        return checkResult[0];
      }
      errorReportInfoList.push({
        fileName: selectedFile.name,
        constructionCode: constructionCode,
        companyInfo: companyInfo,
        projectInfo: projectInfo,
        workerInfo: workerInfo,
      });
      return {
        fileName: selectedFile.name,
        result: "〇",
        value: ""
      };
    }

    /**
     * .xlsxのみ受け付ける
     */
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
      accept: {
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      }
    });

    /**
     * 指定した値を持つ行番号を探して返却する
     * @param target 検索する値
     * @param sheet シート
     * @param startRow 検索開始行
     * @returns 指定した値を持つ行番号
     */
    const getStartRow = (target: string, sheet: any, startRow: number) => {
      // エラー発生行の列にtargetの値がある
      const column = ERROR_REPORT_ERROR_CAUSED_ROW_COLUMN;
      let row = startRow;
      for (; row <= ERROR_REPORT_MAX_ROW; row++) {
        const value = sheet.cell(row, column).value();
        if (value === target) {
          return row;
        }

        // エクセルの最終行か空行が2行続いたら終了　targetが見つからなかった用の処理
        const nextValue = sheet.cell(row + 1, column).value();
        if (row == ERROR_REPORT_MAX_ROW || Utils.isNullOrEmpty(value) && Utils.isNullOrEmpty(nextValue)) {
          break;
        }
      }
      return row;
    }

    /**
     * シートからエラー情報を読み取り引数のエラー情報リストに追加する
     * エラーがあった場合、引数のcheckResultに設定する
     * 空行を見つけたら処理終了。その時の行番号を返却する
     */
    const setErrorInfo = (sheet: any, startRow: number, target: string, errorInfoList: Model.putErrorReportAttach.Info[], selectedFileName: string, checkResult: any[]) => {
      let row = getStartRow(target, sheet, startRow) + 2; // タイトル行から2行進めた行がエラー情報の開始行
      for (; row <= ERROR_REPORT_MAX_ROW; row++) {
        const errorCausedRow = sheet.cell(row, ERROR_REPORT_ERROR_CAUSED_ROW_COLUMN).value(); // エラー発生行
        if (Utils.isNullOrEmpty(errorCausedRow)) {
          // エラー発生行の値が空になったら終了
          break;
        }

        // エラー発生行の値は整数値であることを確認する
        if (!Number.isInteger(errorCausedRow)) {
          checkResult.push({
            fileName: selectedFileName,
            result: "×",
            value: "エラー発生行が数字ではありませんでした。 行数：" + row
          });
          return row;
        }

        const messageId = getTextValue(sheet, row, ERROR_REPORT_MESSAGE_ID_COLUMN); // メッセージID
        const message = getTextValue(sheet, row, ERROR_REPORT_MESSAGE_COLUMN); // エラー・警告内容
        const errorValue = getTextValue(sheet, row, ERROR_REPORT_ERROR_VALUE_COLUMN); // エラーとなった値
        const errorInfo = {
          errorCausedRow: errorCausedRow,
          messageId: messageId,
          message: message,
          errorValue: errorValue,
        };
        errorInfoList.push(errorInfo);

        // エクセルの最終行か空行が2行続いたら終了
        const nextErrorCausedRowValue = sheet.cell(row + 1, ERROR_REPORT_ERROR_CAUSED_ROW_COLUMN).value();
        if (row == ERROR_REPORT_MAX_ROW || Utils.isNullOrEmpty(errorCausedRow) && Utils.isNullOrEmpty(nextErrorCausedRowValue)) {
          break;
        }
      }
      return row;
    }

    /**
     * エクセルの値を文字列で取得する
     * @param sheet 
     * @param row 
     * @param col 
     * @returns 
     */
    const getTextValue = (sheet: any, row: number, col: number) => {
      const cellValue = sheet.cell(row, col).value();
      let plainText = "";
      // 値が存在し、かつ text メソッドを持っているか判定
      if (cellValue === null || cellValue === undefined) {
        plainText = ""; // 空のセルは空文字にする
      } else if (cellValue && typeof cellValue.text === 'function') {
        plainText = cellValue.text(); // RichText(複数の書式で構成されたセル)の場合、text()で文字列を取得
      } else {
        plainText = String(cellValue); // その他は文字列に変換
      }

      // xlsx-populateでは改行コードはそれぞれ以下の変換が行われていたので、元に戻す。
      // ・\n→\r\n
      // ・\r→_x000D_
      // （通常エクセルは\nで改行するので\rは入ることはないが、エラーレポートファイルは\r\nで改行が行われていた。）
      plainText = plainText.replace(/\r\n/g, "\n").replace(/_x000D_/g, "\r");
      return plainText;
    }

    return (
      <>
        <div {...getRootProps()} style={dropzoneStyle}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>ここにファイルをドロップしてください</p>
          ) : (
            <p>API連携エラーレポートファイルをドラッグ＆ドロップするか、クリックしてファイルを選択してください</p>
          )}
        </div>
        <br />
        {errorReportAttachModalMessage ? errorReportAttachModalMessage : ""}
        {errorReportAttachModalResultList.length > 0 && (
          <div>
            <h3>処理結果一覧:</h3>
            <ul>
              {errorReportAttachModalResultList.map((res, index) => (
                <li key={index}>{res.result}: {res.fileName}{res.result !== "〇" ? <> : {res.value}</> : ""}</li>
              ))}
            </ul>
          </div>
        )}
      </>
    );
  }
  // ドラッグアンドドロップ領域のスタイル
  const dropzoneStyle = {
    border: '2px dashed #cccccc',
    borderRadius: '4px',
    padding: '20px',
    justifyContent: 'center',
    cursor: 'pointer',
    width: '100%',
    margin: '0 auto',
  };

  const columns = [
    {
      title: <span>元請支店<br />コード</span>,
      key: "1",
      width: 50,
      dataIndex: "primeCompanyBranchCode",
      sortOrder: (criteria.sortItem !== "1") ? null : criteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder,
      sorter: true,
      showSorterTooltip: false,
      align: "center" as "center",
      render: (text: string, row: Model.MutualAidResultDetailRow) => {
        return (
          <>
            <div className={styles.columnAlignLeft}>{text}</div>
          </>
        )
      },
    },
    {
      title: <span>支店事業<br />コード</span>,
      key: "2",
      width: 50,
      dataIndex: "branchBussinessCode",
      sortOrder: (criteria.sortItem !== "2") ? null : criteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder,
      sorter: true,
      showSorterTooltip: false,
      align: "center" as "center",
      render: (text: string, row: Model.MutualAidResultDetailRow) => {
        return (
          <>
            <div className={styles.columnAlignLeft}>{text}</div>
          </>
        )
      },
    },
    {
      title: <span>工事コード</span>,
      key: "3",
      width: 50,
      dataIndex: "constructionCode",
      sortOrder: (criteria.sortItem !== "3") ? null : criteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder,
      sorter: true,
      showSorterTooltip: false,
      align: "center" as "center",
      render: (text: string, row: Model.MutualAidResultDetailRow) => {
        return (
          <>
            <div className={styles.columnAlignLeft}>{text}</div>
          </>
        )
      },
    },
    {
      title: "支店",
      key: "4",
      width: 50,
      dataIndex: "projectBranchName",
      sortOrder: (criteria.sortItem !== "4") ? null : criteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder,
      sorter: true,
      showSorterTooltip: false,
      align: "center" as "center",
      render: (text: string, row: Model.MutualAidResultDetailRow) => {
        return (
          <>
            <div className={styles.columnAlignLeft}>{text}</div>
          </>
        )
      },
    },
    {
      title: "プロジェクト",
      key: "5",
      width: 400,
      dataIndex: "projectName",
      sortOrder: (criteria.sortItem !== "5") ? null : criteria.sortOrder === "0" ? "ascend" : "descend" as SortOrder,
      sorter: true,
      showSorterTooltip: false,
      align: "center" as "center",
      render: (text: string, row: Model.MutualAidResultDetailRow) => {
        return (
          <>
            <div className={styles.columnAlignLeft}>{text}</div>
          </>
        )
      },
    },
    {
      title: 'エラー有無'
      , dataIndex: 'status'
      , key: '6'
      , align: 'center' as 'center'
      , width: '200px'
      , render: (text: string, row: Model.MutualAidResultDetailRow) => {
        if (text === '1') {
          // 添付有
          return (
            <>
              エラーあり
              <AuthButton
                name={"削除"}
                shape={"round"}
                onClick={() => statusChange(row, CONSTANTS.MUTUAL_AID_ERROR_REPORT_PROCESS_TYPE.ATTACH_DELETE)}
              />
            </>
          );
        } else if (text === '0') {
          // エラーなし
          return (
            <>
              エラーなし
              <AuthButton
                name={"エラーなし解除"}
                shape={"round"}
                onClick={() => statusChange(row, CONSTANTS.MUTUAL_AID_ERROR_REPORT_PROCESS_TYPE.NO_ERROR_RELEASE)}
              />
            </>
          );
        } else {
          // 未設定
          return (
            <>
              未設定
              <AuthButton
                name={"エラーなし"}
                shape={"round"}
                onClick={() => statusChange(row, CONSTANTS.MUTUAL_AID_ERROR_REPORT_PROCESS_TYPE.NO_ERROR)}
              />
            </>
          );
        }
      }
    },
  ];

  /**
   * エラー一覧ダイアログの表
   */
  const errorReportModalColumns = [
    {
      title: 'プロジェクト'
      , width: '250px'
      , dataIndex: 'projectName'
      , align: 'left' as 'left'
      , render: (value: any, row: Model.MutualAidResultErrorReportRow) => {
        return (
          <>
            <span>{ value }</span>
          </>
        )
      }
    },
    {
      title: '種別'
      , width: '70px'
      , dataIndex: 'infoType'
      , align: 'left' as 'left'
      , render: (value: any, row: Model.MutualAidResultErrorReportRow) => {
        return (
          <>
            <span>{ value === "1" ? "会社情報" : value === "2" ? "現場情報" : value === "3" ? "就労情報" : "" }</span>
          </>
        )
      }
    },
    {
      title: '被共済者情報'
      , width: '250px'
      , dataIndex: 'workerInfo'
      , align: 'left' as 'left'
      , render: (value: any, row: Model.MutualAidResultErrorReportRow) => {
        return (
          <>
            {row.infoType === "3" ?
            <>
              一次協力会社：{row.firstPartnerCompanyNames}<br />
              所属会社：{row.belongCompanyName}<br />
              技能者：{row.workerName}<br />
            </> : <>－</> }
          </>
        )
      }
    },
    {
      title: 'メッセージ'
      , width: '400px'
      , dataIndex: 'message'
      , align: 'left' as 'left'
      , render: (value: any, row: Model.MutualAidResultErrorReportRow) => {
        return (
          <>
            <span style={{ whiteSpace: "pre-line" }}>{ value }</span>
          </>
        )
      }
    },
    {
      title: 'エラーとなった値'
      , width: '100px'
      , dataIndex: 'errorValue'
      , align: 'left' as 'left'
      , render: (value: any, row: Model.MutualAidResultErrorReportRow) => {
        return (
          <>
            <span>{ value }</span>
          </>
        )
      }
    },

  ];

  /**
   * 明細検索条件を設定
   */
  const criteriaDataTransfer = (keyValueList: Array<{ key: string, value: any }>) => {
    let newCriteria: Model.MutualAidResultDetailCriteria = {
      attendanceYearMonth: criteria.attendanceYearMonth,
      linkedDatetime: criteria.linkedDatetime,
      sortItem: criteria.sortItem,
      sortOrder: criteria.sortOrder,
      offset: criteria.offset,
      limit: criteria.limit,
    }
    keyValueList.forEach((rec: { key: string, value: any }) => {
      newCriteria[rec.key] = rec.value;
    })
    dispatch(Module.setResultDetailCriteria(newCriteria));
  }

  /**
   * エラーレポート表示検索条件を設定
   */
  const criteriaErrorReportModalDataTransfer = (keyValueList: Array<{ key: string, value: any }>) => {
    let newCriteria: Model.MutualAidErrorReportModalCriteria = {
      sortItem: errorReportModalCriteria.sortItem,
      sortOrder: errorReportModalCriteria.sortOrder,
      offset: errorReportModalCriteria.offset,
      limit: errorReportModalCriteria.limit,
    }
    keyValueList.forEach((rec: { key: string, value: any }) => {
      newCriteria[rec.key] = rec.value;
    })
    dispatch(Module.setErrorReportModalCriteria(newCriteria));
  }

  /**
   * エラー有無：エラーなし解除ボタン押下
   */
  const statusChange = (row: Model.MutualAidResultDetailRow, processType: string) => {
    // 通信結果を初期化する
    dispatch(initApiResult());

    let param: Model.putErrorReportStatus.Request = {
      processType: processType,
      linkedDatetime: criteria.linkedDatetime,
      projectId: row.projectId,
    }

    dispatch(Module.putErrorReportStatusAsync(param));
  }

  /**
   * テーブル検索条件変更時イベント（ソート）
   * @param sorter
   */
  const handleTableChange = (sorter: any) => {

    // NowLoading表示
    dispatch(initApiResult());

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let order = "";
    if (sorter.order === "ascend") {
      order = "0";
    } else if (sorter.order === "descend") {
      order = "1";
    }
    let sortItem = sorter.columnKey
    if (typeof sorter.column === "undefined") {
      sortItem = "";
    }

    criteriaDataTransfer([
      { key: "sortItem", value: sortItem }
      , { key: "sortOrder", value: order }
      , { key: "limit", value: criteria.limit }
      , { key: "offset", value: 0 } // ソート切替時は1ページ目から表示
    ])
  }

  /**
   * ページ変更時イベント（ページ、表示件数）
   * @param pagination
   * @param filters
   */
  const handlePaginationChange = (page: any, pageSize: any) => {

    // NowLoading表示
    dispatch(initApiResult());

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let offsetReset: boolean = false;
    if (criteria.limit !== pageSize) {
      offsetReset = true;
    }

    criteriaDataTransfer([
      { key: "sortItem", value: criteria.sortItem }
      , { key: "sortOrder", value: criteria.sortOrder }
      , { key: "limit", value: pageSize }
      , { key: "offset", value: offsetReset ? 0 : (page - 1) * pageSize }
    ])
  }

  /**
   * ページ変更時イベント（ページ、表示件数）
   * @param pagination
   * @param filters
   */
  const handlePaginationErrorReportModalChange = (page: any, pageSize: any) => {

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let offsetReset: boolean = false;
    if (errorReportModalCriteria.limit !== pageSize) {
      offsetReset = true;
    }

    criteriaErrorReportModalDataTransfer([
      { key: "sortItem", value: errorReportModalCriteria.sortItem }
      , { key: "sortOrder", value: errorReportModalCriteria.sortOrder }
      , { key: "limit", value: pageSize }
      , { key: "offset", value: offsetReset ? 0 : (page - 1) * pageSize }
    ])
  }

  /**
   * 戻るボタン押下
   */
  const onClickBack = () => {
    // API結果情報を初期化します。
    dispatch(initApiResult());
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    history.push(CONSTANTS.PATH_PRIME_MUTUAL_AID_RESULT);
    return <></>;
  }

  /**
   * エラーレポート添付ダイアログを表示
   * @param row 
   */
  const openErrorReportAttachModal = async () => {
    // 初期化してから開く
    errorReportInfoList.length = 0;
    dispatch(Module.setErrorReportAttachModalMessage(""));
    dispatch(Module.setErrorReportAttachModalResultList([]));

    // エラー一覧ダイアログの表示
    dispatch(Module.reflectErrorReportAttachModalState(true));
  }

  /**
   * エラー一覧ダイアログを表示
   * @param row 
   */
  const openErrorReportModal = async () => {

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // NowLoading表示
    dispatch(initApiResult());

    // API呼出引数
    let param: Model.getErrorReport.Request = {
      linkedDatetime: criteria.linkedDatetime,
      sortItem: errorReportModalCriteria.sortItem,
      sortOrder: errorReportModalCriteria.sortOrder,
      offset: errorReportModalCriteria.offset,
      limit: errorReportModalCriteria.limit,
    }
    
    // 同期でAPIを呼び出す（前に取得した値が画面に表示されないようにする）
    await dispatch(Module.getErrorReport(param));

    // エラー一覧ダイアログの表示
    dispatch(Module.reflectErrorReportModalState(true));
  }

  /**
   * ダウンロードダイアログを表示
   */
  const openResultDownloadModal = () => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // ダウンロードダイアログの表示
    dispatch(Module.reflectResultDownloadModalState(true));
  }

  /**
   * エラーレポート添付API
   * @returns 
   */
  const sendErrorReportInfo = () => {

    // リクエストデータの作成
    let postData: Model.putErrorReportAttach.Request = {
      linkedDatetime: criteria.linkedDatetime,
      destList: errorReportInfoList
    }

    let sendJsonText = JSON.stringify(postData);
    if (new Blob([sendJsonText]).size > MAX_BYTES) {
      dispatch(Module.setErrorReportAttachModalMessage("一度に指定できるエラー情報が多すぎます。ファイルを減らしてください。"));
      // 「Now Loading」を解除するため、ステータスに初期値以外を設定する
      dispatch(setApiResult({ status: CONSTANTS.API_STATUS_200, errorCode: "", requestMethod: "", url: "" }));
      return;
    }

    // API呼出
    dispatch(Module.putErrorReportAttachAsync(postData));
  }

  /**
   * ダウンロードダイアログの帳票出力ボタン押下
   */
  const onClickResultDownload = async (values: any) => {

    // パスワード項目にエラーがないか確認　→　エラーがある場合、例外が発生するので、ダウンロードはしない
    await form.validateFields();

    // NowLoading表示
    dispatch(initApiResult());
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // パラメータ作成
    let param: Model.downloadResultRecord.Request = {
      linkedDatetime: criteria.linkedDatetime,
      password: form.getFieldValue('password'),
    }

    // ダウンロード
    dispatch(Module.downloadResultRecord(param));
  }

  /**
   * エラーレポート添付ダイアログの閉じるボタン押下
   */
  const closeErrorReportAttachModal = () => {
    // ステータスを初期化すると元の画面が「Now Loading」になってしまうので、ステータス以外を初期化
    dispatch(setApiResult({ status: apiResult.status, errorCode: "", requestMethod: "", url: "" }));
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // エラーレポート添付ダイアログを閉じる
    dispatch(Module.reflectErrorReportAttachModalState(false));
  }

  /**
   * エラー一覧ダイアログの閉じるボタン押下
   */
  const closeErrorReportModal = () => {
    // ステータスを初期化すると元の画面が「Now Loading」になってしまうので、ステータス以外を初期化
    dispatch(setApiResult({ status: apiResult.status, errorCode: "", requestMethod: "", url: "" }));
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    // 初期化しておく。
    dispatch(Module.prepareMoveToErrorReportModalCriteria(criteria));

    // エラー一覧ダイアログを閉じる
    dispatch(Module.reflectErrorReportModalState(false));
  }

  /**
   * ダウンロードダイアログの閉じるボタン押下
   */
  const onClickResultDownloadCancel = () => {
    // ステータスを初期化すると元の画面が「Now Loading」になってしまうので、ステータス以外を初期化
    dispatch(setApiResult({ status: apiResult.status, errorCode: "", requestMethod: "", url: "" }));
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // ダイアログを閉じる
    dispatch(Module.reflectResultDownloadModalState(false));
  }

  /** 一覧ヘッダー部 */
  const MutualAidResultDetailHeader = () => {
    return (
      <div style={{ whiteSpace: "nowrap" }} className={styles.searchGroup}>
        <div className={styles.flexContainer}>
          <div className={styles.headerTitle}>連携日：</div>
          <div>{formatUtils.formatDateSlash(criteria.linkedDatetime)}</div>
        </div>
      </div>
    )
  }

  // フッターボタンエリアを描画します。
  const ButtonArea = () => {
    return (
      <FooterButtonArea>
        <AuthButton
          name={"戻る"}
          size={"large"}
          shape={"round"}
          onClick={onClickBack}
          className={AuthButtonStyles.backButtonFixed}
          style={{ margin: "10px" }}
        />
        <AuthButton
          name={"エラーレポート添付"}
          authorities={[
            AuthButtonAuthorities.primeSystemMngAuth
          ]}
          size={"large"}
          shape={"round"}
          onClick={openErrorReportAttachModal}
        />
        <AuthButton
          name={"添付済エラー内容表示"}
          authorities={[
            AuthButtonAuthorities.primeSystemMngAuth
          ]}
          size={"large"}
          shape={"round"}
          onClick={openErrorReportModal}
        />
        <AuthButton
          name={"連携結果取得"}
          authorities={[
            AuthButtonAuthorities.primeSystemMngAuth
          ]}
          size={"large"}
          shape={"round"}
          onClick={openResultDownloadModal}
        />
      </FooterButtonArea>
    )
  }

  /** エラーレポート添付ダイアログ表示内容 */
  const ErrorReportAttachModalContent = () => {
    return (
      <div className={styles.contentArea} >
        連携日：{formatUtils.formatDateSlash(criteria.linkedDatetime)}
        <CsvUploader />
      </div>
    );
  }

  /** エラー一覧ダイアログ表示内容 */
  const ErrorReportModalContent = () => {
    return (
      <div className={styles.contentArea} >
        連携日：{formatUtils.formatDateSlash(criteria.linkedDatetime)}
        <CommonMessage searchNoDataName="エラーレポート" />

        {errorReportModalList.length > 0 ?
          <Content
            style={{ margin: "auto", textAlign: "left" }}
          >
            <div className={"topPagination"} style={{ marginTop: "10px" }}>
              <Pagination
                className={"commonPagination topLeftPagination"}
                defaultPageSize={10}
                pageSize={errorReportModalCriteria.limit}
                pageSizeOptions={["5", "10", "20", "50", "100"]}
                showSizeChanger={true}
                showTotal={() => (<span>１ページあたりの表示件数</span>)}
                locale={{ items_per_page: "件/ページ" }}
                onChange={handlePaginationErrorReportModalChange}
                onShowSizeChange={(page, size) => {
                  handlePaginationErrorReportModalChange(page, size); // ページサイズ変更時に1ページ目へ戻す
                }}
              />
              <Pagination
                className={"commonPagination topRightPagination"}
                total={errorReportModalTotal}
                current={errorReportModalCriteria.offset / errorReportModalCriteria.limit + 1}
                pageSize={errorReportModalCriteria.limit}
                showTotal={(total) => <><span>{total.toLocaleString()}</span> 件数中、<span>{(errorReportModalCriteria.offset + 1).toLocaleString()}</span> － <span>{total <= errorReportModalCriteria.offset + errorReportModalCriteria.limit ? total.toLocaleString() : (errorReportModalCriteria.offset + errorReportModalCriteria.limit).toLocaleString()}</span> 件</>}
                onChange={handlePaginationErrorReportModalChange}
              />
            </div>
            <Table
              columns={errorReportModalColumns}
              size='small'
              dataSource={errorReportModalList}
              scroll={{ x: 500, y: 500 }}
              pagination={false}
              className="hoverNotBackground"
              style={{ marginLeft: "20px" }}
              bordered
            />
            <Pagination
              className={"commonPagination bottomPagination"}
              total={errorReportModalTotal}
              current={errorReportModalCriteria.offset / errorReportModalCriteria.limit + 1}
              pageSize={errorReportModalCriteria.limit}
              onChange={handlePaginationErrorReportModalChange}
            />
          </Content> : <></>
        }
      </div>
    );
  }

  /** ダウンロードダイアログ表示内容 */
  const ResultDownloadModalContent = () => {
    return (
      <div className={styles.contentArea} >
        ダウンロードするZIPファイルには解凍に必要なパスワードを設定します。<br />
        パスワードを設定してください。
        <Form
          form={form}
          layout="inline"
          method="POST"
          onFinish={onClickResultDownload}
          className={styles.form}
          initialValues={{
            'password': ""
          }}
        >
          <PasswordContent />
        </Form>
      </div>
    );
  }

  /** ダウンロードダイアログのパスワード項目 */
  const PasswordContent = () => {
    return (
      <div className={styles.passwordArea}>
        <Form.Item
          name="password"
          id="password"
          label={"zipファイルの暗号化パスワード(1文字以上の任意の文字列)"}
          rules={[
            {
              required: true,
              message: messagesUtils.getMessage("ERROR_REQUIRED_INPUT", ["パスワード"]),
            },
            {
              pattern: validationRules.alphanumeric,
              message: messagesUtils.getMessage("ERROR_ALPHANUMERIC", ["パスワード"]),
            },
            {
              max: CONSTANTS.PASSWORD_MAX_LENGTH,
              message: messagesUtils.getMessage("ERROR_MAX_LENGTH", ["パスワード", CONSTANTS.PASSWORD_MAX_LENGTH.toString()]),
            }
          ]}
        >
          <Input.Password
            placeholder={"パスワード"}
            maxLength={CONSTANTS.PASSWORD_MAX_LENGTH}
            iconRender={(visible: any) => (visible ? <EyeInvisibleFilled /> : <EyeFilled />)}
          />
        </Form.Item>
      </div>
    );
  }

  // モーダル表示時にメッセージを表示しないように切り替えます。
  const CommonMessages = () => {
    if (errorReportModalVisibleState === true || resultDownloadModalVisibleState === true || errorReportAttachModalVisibleState === true) {
      return (<></>);
    }
    return (<CommonMessage searchNoDataName="プロジェクト" />);
  }

  return (

    <Layout>
      <Header />
      <Content>
        <FunctionTitle title={props.title} />
        <CommonMessages />
        <MutualAidResultDetailHeader />
        {
          total > 0 && dataList.length > 0 && dataList[0].key !== '' ?
            <>
              <div style={{ width: "100%" }}>
                <div className={"topPagination"}>
                  <Pagination
                    className={"commonPagination topLeftPagination"}
                    defaultPageSize={10}
                    pageSize={criteria.limit}
                    pageSizeOptions={["5", "10", "20", "50", "100"]}
                    showSizeChanger={true}
                    showTotal={() => (<span>１ページあたりの表示件数</span>)}
                    locale={{ items_per_page: "件/ページ" }}
                    onChange={handlePaginationChange}
                    onShowSizeChange={(page, size) => {
                      handlePaginationChange(page, size); // ページサイズ変更時に1ページ目へ戻す
                    }}
                  />
                  <Pagination
                    className={"commonPagination topRightPagination"}
                    total={total}
                    current={criteria.offset / criteria.limit + 1}
                    pageSize={criteria.limit}
                    showTotal={(total) => <><span>{total.toLocaleString()}</span> 件数中、<span>{(criteria.offset + 1).toLocaleString()}</span> － <span>{total <= criteria.offset + criteria.limit ? total.toLocaleString() : (criteria.offset + criteria.limit).toLocaleString()}</span> 件</>}
                    onChange={handlePaginationChange}
                  />
                </div>
                <Table
                  size="small"
                  scroll={{ x: 1000 }}
                  sticky={{ offsetHeader: -31 }}
                  columns={columns}
                  dataSource={dataList}
                  pagination={false}
                  onChange={(pagination, filters, sorter) => handleTableChange(sorter)}
                >
                </Table>
                <Pagination
                  className={"commonPagination bottomPagination"}
                  total={total}
                  current={criteria.offset / criteria.limit + 1}
                  pageSize={criteria.limit}
                  onChange={handlePaginationChange}
                />
              </div>
            </>
            : <></>
        }
      </Content>
      <ButtonArea />
      <Footer />

      {/* エラーレポート添付ダイアログ */}
      <Modal
        visible={errorReportAttachModalVisibleState}
        footer={[
          <AuthButton
            name={"閉じる"}
            size={"large"}
            shape={"round"}
            onClick={closeErrorReportAttachModal}
            className={AuthButtonStyles.backButtonFixed}
            style={{ margin: "10px" }}
          />,
        ]}
        destroyOnClose
        closable={false}
        width={1150}
        >
        <Layout>
          <ErrorReportAttachModalContent />
        </Layout>
      </Modal>

      {/* エラー一覧ダイアログ */}
      <Modal
        visible={errorReportModalVisibleState}
        footer={[
          <AuthButton
            name={"閉じる"}
            size={"large"}
            shape={"round"}
            onClick={closeErrorReportModal}
            className={AuthButtonStyles.backButtonFixed}
            style={{ margin: "10px" }}
          />,
        ]}
        destroyOnClose
        closable={false}
        width={1500}
        >
        <Layout>
          <ErrorReportModalContent />
        </Layout>
      </Modal>

      {/* ダウンロードダイアログ */}
      <Modal
        visible={resultDownloadModalVisibleState}
        footer={[
          <AuthButton
            name={"帳票出力"}
            size={"large"}
            shape={"round"}
            onClick={onClickResultDownload}
            className={AuthButtonStyles.authButtonFixed}
          />,
          <AuthButton
            name={"閉じる"}
            size={"large"}
            shape={"round"}
            onClick={onClickResultDownloadCancel}
            className={AuthButtonStyles.backButtonFixed}
            style={{ margin: "10px" }}
          />,
        ]}
        destroyOnClose
        closable={false}
        width={900}
        >
        <Layout>
          <ResultDownloadModalContent />
        </Layout>
      </Modal>
    </Layout>
  );
}
